/**
 * created by li si yi
 * 资源下载申请待办处理
 */
import React, {Component} from 'react';
import Apply from "../../../../resource/components/apply";
import {connect} from "react-redux";
import BaseComponent from "../../../../../base/BaseComponent";

class Zyxzsq extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    showModalApply(record) {
        this.showApply.show(true, record)
    };

    data = {};

    isSupport(data) {
        this.data = data;
        if (this.data && this.data.data && this.data.data.id && this.data.activitiCategoryKey === "zyxzsq") {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'IconResource';
        return icon
    };
    call = () => {
    };

    handle = (data, call) => {
        this.showModalApply(data.data);
        if (call) {
            this.call = call;
        }
    };

    render() {
        return (
            <div style={{display: 'none'}}>
                <Apply ref={(ref) => this.showApply = ref}
                       title={'查看申请'}
                       name={'待我审核'}
                       disabled={true}
                       callBackData={() => {
                           this.call && this.call()
                       }}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(Zyxzsq)